export enum AssetType {
  DOCUMENT = 'document',
  IMAGE = 'image',
  MODEL = 'model',
  MANIFEST = 'manifest',
  SCAN = 'scan',
}
